import script from "./studyItemNormal.vue?vue&type=script&setup=true&lang=js"
export * from "./studyItemNormal.vue?vue&type=script&setup=true&lang=js"

import "./studyItemNormal.vue?vue&type=style&index=0&id=d8d4d110&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8d4d110"]])

export default __exports__